import { IStatusPill } from './StatusPill.types';
import { statusIconMapping } from './StatusPill.const';
import { useIntl } from 'react-intl';
import { Chip } from '@frontend/ui-elements';
import { getBackgroundColor, getTextColor } from './StatusPill.utils';
import { useTheme } from '@mui/material';

export default function StatusPill({ status }: IStatusPill) {
  const Icon = statusIconMapping[status] || undefined;
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Chip
      label={intl.formatMessage({
        id: `customer-platform.api.${status}`,
      })}
      icon={<Icon size={14} />}
      colorText={getTextColor({ status, theme })}
      colorBackground={getBackgroundColor({ status, theme })}
    />
  );
}
